import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";

const { Types, Creators } = createActions({
  getFileRequest: ["leave_id"],
  getFileSuccess: ["listFile"],
  getFileFailure: null,
  clearGetFileData: null,
});

export const GetFileTypes = Types;
export default Creators;

export const INITIAL_STATE = Immutable({
  leave_id: null,
  fetching: null,
  success: null,
  listFile: null,
  error: null,
});

export const GetFileSelectors = {
  getData: (state: any) => state.getFile.data,
  isFetching: (state: any) => state.getFile.fetching,
  isSuccess: (state: any) => state.getFile.success,
  hasError: (state: any) => state.getFile.error,
};

export const request = (state: any, { leave_id }: any) => {
  const updateData = {
    fetching: true,
    success: false,
    error: false,
    leave_id,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const success = (state: any, action: any) => {
  const { listFile } = action;
  const updateData = {
    fetching: false,
    success: true,
    error: false,
    listFile,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const failure = (state: any) => {
  const updateData = {
    fetching: false,
    success: false,
    error: true,
    listFile: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const clearGetFileData = (state: any) => {
  const updateData = {
    listFile: null,
    leave_id: null,
  };
  return state.merge ? state.merge(updateData) : { ...state, ...updateData };
};

export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_FILE_REQUEST]: request,
  [Types.GET_FILE_SUCCESS]: success,
  [Types.GET_FILE_FAILURE]: failure,
  [Types.CLEAR_GET_FILE_DATA]: clearGetFileData,
});
